import { render, staticRenderFns } from "./Obsolete.vue?vue&type=template&id=6d004d34&scoped=true&"
import script from "./Obsolete.vue?vue&type=script&lang=js&"
export * from "./Obsolete.vue?vue&type=script&lang=js&"
import style0 from "./Obsolete.vue?vue&type=style&index=0&id=6d004d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d004d34",
  null
  
)

export default component.exports